import { css } from 'styled-components';
import { ISIconProps } from './models';

const getSize = (size: string) => {
  switch (size) {
    case 'small':
      return `
          width: 20px; //dont touch this :)
        `;
    case 'medium':
      return `
          width: 30px; //placeholder size - change if needed
        `;
    case 'large':
      return `
          width: 40px; //placeholder size - change if needed
        `;
    case 'larger':
      return `
          width: 50px; //dont touch this :)
        `;
    default:
      break;
  }
};

export const Icon = ({ size }: ISIconProps) => {
  return css`
    ${getSize(size)}
  `;
};
